import useSWR from 'swr';
import { subscriptionApi } from '../../api/subscription.api';

export function useSubscription() {
  const { data, error, isLoading, mutate } = useSWR(
    'my-subscription',
    () => subscriptionApi.getMySubscription().then((res) => res.data),
    {
      revalidateOnFocus: false,
      dedupingInterval: 30000,
    }
  );

  const sub = data?.subscription;
  const isFree = sub?.status === 'free';
  const isPaid = sub?.status === 'active' || sub?.status === 'trialing';
  const creditBalance = data?.creditBalance ?? 0;
  const freeSmsUsed = sub?.freeSmsUsed ?? 0;
  const freeSmsLimit = sub?.freeSmsLimit ?? 25;
  const freeSmsRemaining = Math.max(0, freeSmsLimit - freeSmsUsed);
  const freeLimitExceeded = isFree && freeSmsUsed >= freeSmsLimit && creditBalance <= 0;
  const canSendSms = data?.canSendSms ?? false;
  const workflowsEnabled = data?.workflowsEnabled ?? false;
  const planName = isFree ? 'Free' : sub?.SubscriptionPlan?.name || 'Free';
  const isTrialing = sub?.status === 'trialing';
  const trialDaysLeft = data?.trialDaysLeft ?? 0;
  const inGracePeriod = data?.inGracePeriod ?? false;
  const graceDaysLeft = data?.graceDaysLeft ?? 0;

  return {
    data,
    sub,
    isFree,
    isPaid,
    isTrialing,
    trialDaysLeft,
    inGracePeriod,
    graceDaysLeft,
    creditBalance,
    freeSmsUsed,
    freeSmsLimit,
    freeSmsRemaining,
    freeLimitExceeded,
    canSendSms,
    workflowsEnabled,
    planName,
    loading: isLoading,
    error,
    refresh: mutate,
  };
}
